import React from 'react';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import { NODE_COLORS } from '../../config/theme';
import TextEditorModal from './TextEditorModal';

export default function WorkspacePromptEditor({ open, onClose, value = '', onSave, availableVariables = [] }) {
  return (
    <TextEditorModal
      open={open}
      onClose={onClose}
      title="Workspace BI Prompt"
      nodeIcon={<AutoAwesomeOutlinedIcon sx={{ fontSize: 16 }} />}
      nodeColor={NODE_COLORS.AI}
      value={value}
      onSave={onSave}
      availableVariables={availableVariables}
      placeholder={"Workspace-wide instructions for the BI analytics assistant.\n\nUse the {{project_contexts}} placeholder to inject the context of the projects a client is asking about.\n\nExample:\nYou are a BI assistant for our workspace. Answer in plain, non-technical language and never mention code or technical details.\n\nProject context:\n{{project_contexts}}"}
    />
  );
}
